<template>
    <div>
        <div style="display: flex;align-items: center;justify-content: center">
            <div class="container-table" style="width:100%">
                <div class="header-box  display-flex">
                    <div class="title-box display-flex-auto">
                        精灵助手后台管理
                    </div>
                </div>
                <div class="header-box  display-flex">
                    <div class="title-box1 display-flex ">
                        <div style="line-height: 30px">
                            问题名称：
                        </div>
                        <div @keyup.enter="submit">
                            <el-input
                                    size="mini"
                                    placeholder="请输入内容"
                                    prefix-icon="el-icon-search"
                                    v-model="search">
                            </el-input>
                        </div>
                    </div>
                    <div class="button-box  display-flex">
                        <div>
                            <el-button size="mini" type="primary" @click="handleClick(2)">添加</el-button>
                        </div>
                    </div>
                </div>
                <template>
                    <el-table
                            border
                            :data="tableData.rows">
                        <el-table-column
                                label="序号"
                                type="index"
                                width="55">
                        </el-table-column>
                        <el-table-column
                                prop="title"
                                label="问题名称 "
                                width="400">
                        </el-table-column>
                        <el-table-column
                                prop="content"
                                label="答案内容"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                width="100">
                            <template slot-scope="scope">
                                <div style="display: flex">
                                    <el-button type="text" size="small" @click="handleClick(0,scope.row)">查看</el-button>
                                    <el-button type="text" size="small" @click="handleClick(1,scope.row)">删除</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            v-if="total"
                            layout="prev, pager, next"
                            :total="total">
                    </el-pagination>
                </template>
            </div>
        </div>

        <!--TODO 添加页面弹出层 -->
        <div class="dialog">
            <el-dialog
                    :title="title"
                    :visible.sync="dialogVisible"
                    width="45%"
            >
            <span>
                <div class="dialog_Input">
                    <div style="width: 15%;font-size: 17px">
                        标题：
                    </div>
                    <div style="width: 85%">
                       <el-input v-model.trim="input1" placeholder="请输入要添加的标题"></el-input>
                    </div>
                </div>
                <div class="dialog_Input">
                    <div style="width: 15%;font-size: 17px">
                        内容：
                    </div>
                    <div style="width: 85%">
                        <el-input
                                type="textarea"
                                :autosize="{ minRows: 5, maxRows: 5}"
                                placeholder="请输入要添加的内容"
                                v-model.trim="input2">
                        </el-input>
                    </div>
                </div>
            </span>
                <span slot="footer" class="dialog-footer">
                <el-button size="mini" v-if="dialogVisible && !add "  @click="dialogVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="handle">确 定</el-button>
            </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                add:false, //判断是添加 还是查看界面标识
                title:'',
                input1: '',
                input2: '',
                dialogVisible: false,
                total: '',
                search: '',
                value: '',
                tableData: [{
                    task: '您好，xx山区发生了地震，需要获得震后模型，模型比例按照1:1000展示。任务时间为3天，出发吧，飞行者！',
                    starLevel: '1星',
                    date: '2016-05-03',
                }, {
                    task: '内蒙古通辽市 1518 弄',
                    starLevel: '5星',
                    date: '1998-05-03',
                }],
                options: [{
                    value: '1',
                    label: '全部'
                }, {
                    value: '2',
                    label: '考核'
                }, {
                    value: '3',
                    label: '练习'
                }],
            }
        },
        methods: {
            //添加弹出层
            handle(){
                //查看
                if (this.add){
                    this.dialogVisible = false
                    this.add = false
                }else{
                    //添加
                    if(this.input1 === '' && this.input2 !== '' ){
                        this.$message.error('请填写您要添加问题的题目');
                    }
                    else if (this.input2 === '' && this.input1 !== '' ){
                        this.$message.error('请填写您要添加问题的内容');
                    }
                    else if (this.input1 === '' && this.input2 === '' ){
                        this.$message.error('请填写您要添加的问题');
                    }
                    else{
                        let params={
                            title:this.input1,
                            content:this.input2,
                            type:1,
                        }
                        this.$axios.get(this.URL.uQuestion.saveUQuestion,{params})
                            .then(res=>{
                                if (res.status === 200) {
                                    this.$message({
                                        message: '添加问题成功',
                                        type: 'success'
                                    });
                                    this.dialogVisible = false;
                                    this.submit()
                                } else {
                                    this.$message.error('服务器错误，请稍后再试');
                                }
                            })
                    }
                }
            },
            handleClick(index, row) {
                //id参数
                if (row){
                    var id = row.id
                }

                if (index === 0) {
                    this.dialogVisible = true;
                    this.title = '查看问题';
                    this.input2 = row.content ;
                    this.input1 = row.title;
                    this.add = true
                }else if(index === 2){
                    this.add = false
                    this.dialogVisible = true
                    console.log(this.dialogVisible);

                    this.title = '请添加问题'
                } else {
                    let params = {
                        id: id
                    }
                    this.$axios.get(this.URL.uQuestion.deluQuestion, {params})
                        .then(res => {
                            if (res.status === 200) {
                                this.$message({
                                    message: '删除问题es成功',
                                    type: 'success'
                                });
                                this.submit()
                            } else {
                                this.$message.error('服务器错误，请稍后再试');
                            }
                        })
                }
            },
            //列表查询接口
            submit() {
                let params = {
                    questionStr: this.search,
                    type: 1,
                }
                this.$axios.get(this.URL.uQuestion.backList, {params}).then(res => {
                    if (res.status === 200) {
                        this.tableData = res.data
                    }
                })
            },

            backMain() {
                this.goMain('main');
            }
        },
        mounted() {
            this.submit()
        },
        watch:{
            dialogVisible(val){
                if (!val){
                    this.input2 = ''
                    this.input1 = ''
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .title-box1 {
        color: #606266;
        height: 30px;
        border-width: 0 1px 1px 1px;
        border-style: solid;
        border-color: #ebeef5;
        width: 100%;
    }

    .header-box {
        position: relative;
    }

    .title-box {
        color: #606266;
        height: 30px;
        border: 1px solid #ebeef5;
        width: 100%;
    }

    .button-box {
        position: absolute;
        right: 0;
        bottom: 2px;
        div {
            margin-left: 3px;
        }
    }

    .display {
        .el-table .cell {
            display: flex;
        }
    }

    .dialog_Input:first-child {
        margin-top: 0;
    }

    .dialog_Input {
        display: flex;
        align-items: center;
        margin-top: 20px;
    }

    .dialog {

        /deep/ .el-dialog__header {
            text-align: center;
            padding: 40px 20px 10px;
        }
        /deep/ .el-dialog__title {
            font-size: 24px !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/audit/assistant/audit-assistan.vue